module.exports = __webpack_public_path__ + "img/billing_assurance_report.8152b204.svg";